import React, { useEffect, useState } from 'react';
import { warehouseApi, productsApi, suppliersApi } from '../services/api';

export default function Warehouse() {
  const [invoices, setInvoices] = useState([]);
  const [lowStock, setLowStock] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('invoices');
  const [showUpload, setShowUpload] = useState(false);
  const [uploadForm, setUploadForm] = useState({ supplier_id: '', invoice_number: '', invoice_date: '', total: '' });
  const [uploadFile, setUploadFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [parsedItems, setParsedItems] = useState(null);
  const [msg, setMsg] = useState('');

  function load() {
    setLoading(true);
    Promise.all([warehouseApi.supplierInvoices(), warehouseApi.lowStock(), suppliersApi.list()])
      .then(([inv, ls, sup]) => { setInvoices(inv); setLowStock(ls); setSuppliers(sup); })
      .finally(() => setLoading(false));
  }
  useEffect(() => { load(); }, []);

  async function uploadInvoice(e) {
    e.preventDefault();
    setUploading(true);
    try {
      const fd = new FormData();
      Object.entries(uploadForm).forEach(([k, v]) => fd.append(k, v));
      if (uploadFile) fd.append('pdf', uploadFile);
      const result = await warehouseApi.createSupplierInvoice(fd);
      setParsedItems(result.parsed_items);
      setMsg('Faktura nahrána a zpracována AI');
      setShowUpload(false);
      load();
    } finally {
      setUploading(false);
    }
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">🏭 Sklad</h1>
        <button className="btn btn-primary" onClick={() => setShowUpload(true)}>📄 Nahrát fakturu dodavatele</button>
      </div>

      {msg && <div className="alert alert-success">{msg}</div>}

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 16 }}>
        {[['invoices','Faktury dodavatelů'],['low_stock',`Nízký sklad (${lowStock.length})`]].map(([v,l]) => (
          <button key={v} className={`btn ${tab===v ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab(v)}>{l}</button>
        ))}
      </div>

      {loading && <div className="loading-center"><div className="spinner" /></div>}

      {tab === 'invoices' && !loading && (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Dodavatel</th><th>Č. faktury</th><th>Datum</th><th>Celkem</th><th>Status</th><th></th></tr>
              </thead>
              <tbody>
                {invoices.map(inv => (
                  <tr key={inv.id}>
                    <td>{inv.supplier_name || '—'}</td>
                    <td style={{ fontWeight: 600 }}>{inv.invoice_number || '—'}</td>
                    <td style={{ fontSize: 12 }}>{inv.invoice_date}</td>
                    <td style={{ fontWeight: 700 }}>{inv.total?.toFixed(2)} {inv.currency}</td>
                    <td><span className={`badge ${inv.status === 'processed' ? 'badge-paid' : 'badge-waiting'}`}>{inv.status}</span></td>
                    <td>
                      {inv.pdf_path && <a href={`/api/uploads/${inv.pdf_path.split('/').pop()}`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm">PDF</a>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {invoices.length === 0 && <div className="empty-state">Žádné faktury dodavatelů</div>}
          </div>
        </div>
      )}

      {tab === 'low_stock' && !loading && (
        <div className="card">
          {lowStock.length === 0 ? (
            <div className="empty-state">✅ Vše v pořádku</div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr><th>Produkt</th><th style={{ textAlign: 'right' }}>Sklad</th><th style={{ textAlign: 'right' }}>Min. sklad</th><th>Stav</th></tr>
                </thead>
                <tbody>
                  {lowStock.map(p => (
                    <tr key={p.id}>
                      <td style={{ fontWeight: 600 }}>{p.name}</td>
                      <td style={{ textAlign: 'right', fontWeight: 700, color: p.stock_quantity <= 0 ? 'var(--red)' : 'var(--orange)' }}>{p.stock_quantity} ks</td>
                      <td style={{ textAlign: 'right', color: 'var(--text-muted)' }}>{p.min_stock} ks</td>
                      <td><span className="badge badge-overdue">{p.stock_quantity <= 0 ? '❌ Vyprodáno' : '⚠ Dochází'}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Upload modal */}
      {showUpload && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowUpload(false)}>
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">Nahrát fakturu dodavatele</div>
              <button className="btn btn-secondary btn-sm" onClick={() => setShowUpload(false)}>✕</button>
            </div>
            <form onSubmit={uploadInvoice}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Dodavatel</label>
                  <select className="form-control" value={uploadForm.supplier_id} onChange={e => setUploadForm(f => ({...f, supplier_id: e.target.value}))}>
                    <option value="">— vyberte —</option>
                    {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Číslo faktury</label>
                  <input className="form-control" value={uploadForm.invoice_number} onChange={e => setUploadForm(f => ({...f, invoice_number: e.target.value}))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Datum faktury</label>
                  <input className="form-control" type="date" value={uploadForm.invoice_date} onChange={e => setUploadForm(f => ({...f, invoice_date: e.target.value}))} />
                </div>
                <div className="form-group">
                  <label className="form-label">PDF faktura (AI vytěží položky)</label>
                  <input type="file" accept=".pdf" onChange={e => setUploadFile(e.target.files[0])} />
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>AI automaticky extrahuje položky z faktury</div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowUpload(false)}>Zrušit</button>
                <button type="submit" className="btn btn-primary" disabled={uploading}>{uploading ? '⏳ Zpracovávám AI...' : 'Nahrát a zpracovat'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Parsed items modal */}
      {parsedItems && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">AI extrahované položky</div>
            </div>
            <div className="modal-body">
              <table>
                <thead><tr><th>Produkt</th><th>Ks</th><th>Cena/ks</th><th>Celkem</th></tr></thead>
                <tbody>
                  {parsedItems.map((item, i) => (
                    <tr key={i}>
                      <td>{item.product_name}</td>
                      <td>{item.quantity} {item.unit}</td>
                      <td>{item.price_unit} Kč</td>
                      <td style={{ fontWeight: 700 }}>{item.price_total} Kč</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => setParsedItems(null)}>Zavřít</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
